// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import SimulationPreviewPanel from './SimulationPreviewPanel';
import './DashboardContentContainer.scss';

type Props = {
  simulations: ?Array<any>,
  loadDetails: Function,
};

export class DashboardContentContainer extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      simulations: this.props.simulations,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(this.props.simulations, nextProps.simulations)) {
      this.setState({
        simulations: nextProps.simulations,
      });
    }
  }

  generateContent = () => {
    const content = [];
    for (let i = 0; i < this.state.simulations.length; i += 1) {
      const startTime = new Date(this.state.simulations[i].triggeredTime);
      content.push(<SimulationPreviewPanel
        CohortID={this.state.simulations[i].cohortID}
        SimulationID={this.state.simulations[i].simulationID}
        StartTime={startTime.toString()}
        key={i}
        Status={this.state.simulations[i].status}
        Duration={this.state.simulations[i].duration}
        onClickHandler={this.props.loadDetails}
      />);
    }
    const showSimulations = content.length === 0 ? 'hide' : '';
    if (showSimulations !== '') {
      return (
        <div className="no-simulations">
          <span className="head">No Simulations Found</span>
          <p>You have not run any simulations or you do not have any active simulations</p>
        </div>
      );
    }
    return (
      <table className="center-table table is-striped is-fullwidth">
        <thead>
          <tr className={showSimulations}>
            <td>SIMULATION ID</td>
            <td>COHORT ID</td>
            <td>START TIME</td>
            <td>DURATION</td>
            <td>STATUS</td>
            <td>OPTIONS</td>
          </tr>
        </thead>
        <tbody>
          {content}
        </tbody>

      </table>
    );
  };

  render() {
    return (
      <div className="SimulationContentContainer">
        {this.generateContent()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/simulation/DashboardContentContainer.jsx
 **/